import { session, setAuthHeader } from '@/api/session'

export default {
  getAllEmailTemplates (limit, offset) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/email_template/?limit=${limit}&offset=${offset}`
    return session.get(url, setAuthHeader())
  },
  getEmailTemplateDetail (templateId) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/email_template/${templateId}/`
    return session.get(url, setAuthHeader())
  },
  saveEmailTemplateDetail (templateId, payload) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/email_template/${templateId}/`
    return session.put(url, payload, setAuthHeader())
  },
  createEmailTemplate (payload) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/email_template/`
    return session.post(url, payload, setAuthHeader())
  },
  removeEmailTemplate (templateId) {
    let url = `${process.env.VUE_APP_BACKEND_API_URL}commons/email_template/${templateId}/`
    return session.delete(url, setAuthHeader())
  }
}
